// extracted by mini-css-extract-plugin
export default {"contentText":"ConfirmationDialog_contentText__fqRrR"};